<template>
    <div id="card-class-manage">
        <div class="vx-row flex justify-center mb-4">
            <div class="vx-col w-full flex">
                <div class="vx-col xl:w-1/4 lg:w-1/3 md:w-1/2 w-full">
                    <label class="vs-input--label">Chọn Template</label>
                    <v-select class="" v-model="selectTemplate" :options="dataTemplate" :clearable="false"
                        :reduce="(options) => options.value" @input="checkValue">
                    </v-select>
                </div>
                <div class="vx-col xl:w-1/4 lg:w-1/3 md:w-1/2 w-full ml-8" v-if="checkTemplate">
                    <label class="vs-input--label">Template Detail</label>
                    <v-select class="" v-model="selectTemplateDetails" :options="dataTemplateDetails" :clearable="false"
                        :reduce="(options) => options.value" @input="checkValueDetail">
                    </v-select>
                </div>
                <div class="vx-col xl:w-1/4 lg:w-2/3 w-1/2 ml-8 mt-6" v-if="checkTemplateDetails">
                    <vs-button class="xl:float-none lg:float-right md:float-none float-right" color="primary"
                        icon-pack="feather" icon="icon-plus" @click="ClearValue">
                        Thêm ngôn ngữ
                    </vs-button>
                </div>
            </div>
            <div class="vx-col w-full flex" v-if="checkTemplateDetails">
                <div class="vx-col xl:w-1/4 lg:w-1/3 md:w-1/2 w-full">
                    <label class="vs-input--label">Chọn ngôn ngữ</label>
                    <v-select class="" v-model="selectLanguage" :options="dataLanguage" :clearable="false"
                        :reduce="(options) => options.value" @input="openHtml">
                    </v-select>
                </div>
                <span class="mt-8" @click="checkOpenLanguage">
                    <vx-tooltip class="position-icon mr-2" :text="$t('button.edit')" position="top">
                        <feather-icon svg-classes="h-4 w-6" icon="EditIcon" color="primary"
                            class="password-toggle"></feather-icon>
                    </vx-tooltip>
                </span>
                <span class="mt-8" @click="deleteLanguage">
                    <vx-tooltip class="position-icon mr-2" :text="$t('button.delete')" position="top">
                        <feather-icon svg-classes="h-4 w-6" icon="TrashIcon" color="primary"
                            class="password-toggle"></feather-icon>
                    </vx-tooltip>
                </span>
            </div>
        </div>
        <div class="vx-card mt-4 p-4 vx-col w-full customizeTopEditor" >
            <vs-input label="Tiêu đề" class="customizeTitle" placeholder="Tiêu đề" v-model="formUpdate.subject" />
        </div>
        <div class="vx-card mt-4 p-4 vx-col w-full customizeTopEditor" v-if="checkHtml">
            <div class="center con-selects">

                <!-- Two-way Data-Binding -->
                <EmailEditor :appearance="appearance" :min-height="minHeight" :project-id="projectId" :locale="locale"
                    :tools="tools" :options="options" ref="emailEditor" v-on:load="editorLoaded" />


            </div>
        </div>
        <div class="vx-card p-2 customizeTopEditor" v-if="checkHtml">
            <div class="vx-row">
                <div class="vx-col w-full" style="margin-bottom: 10px;">
                    <p><b>Available variables:</b> {USER_FIRST_NAME}, {USER_LAST_NAME}, {DASHBOARD_URL},
                        {USER_LOGIN_EMAIL}, {USER_LOGIN_PASSWORD}, {LOGO_URL}, {SIGNATURE},
                        {RECIPIENTS_EMAIL_ADDRESS},</p>
                </div>
            </div>
        </div>

        <div class="vx-card p-2" v-if="checkHtml">
            <div class="vx-row">
                <div class="vx-col w-full">
                    <vs-button v-on:click="saveDesign" class="float-right mr-5">Save Design</vs-button>
                    <vs-button v-on:click="exportHtml" class="float-right mr-5">Export HTML</vs-button>
                </div>
            </div>
        </div>
        <vs-popup title="Thêm mới Ngôn ngữ" :active.sync="openLanguage">
            <div class="vx-col md:w-full">
                <label class="vs-input--label required"> Ngôn ngữ</label><br />
                <vs-input class="w-full" v-model="form.language" />
            </div>
            <div class="vx-row">
                <div class="vx-col w-full mt-4">
                    <div class="mt-2 flex flex-wrap items-center justify-end mb-2">
                        <vs-button class="mr-5" @click="addLanguage">Thêm mới</vs-button>
                        <vs-button class="" color="danger" type="border" @click="openLanguage = false">{{
                        $t('tasks.close')
                    }}
                        </vs-button>
                    </div>
                </div>
            </div>
        </vs-popup>
        <vs-popup title="Cập nhật ngôn ngữ" :active.sync="openLanguageUpdate">
            <div class="vx-col md:w-full">
                <label class="vs-input--label required"> Ngôn ngữ</label><br />
                <vs-input class="w-full" v-model="formUpdate.language" />
            </div>
            <div class="vx-row">
                <div class="vx-col w-full mt-4">
                    <div class="mt-2 flex flex-wrap items-center justify-end mb-2">
                        <vs-button class="mr-5" @click="updateLanguage">Cập nhật</vs-button>
                        <vs-button class="" color="danger" type="border" @click="openLanguageUpdate = false">{{
                        $t('tasks.close')
                            }}
                        </vs-button>
                    </div>
                </div>
            </div>
        </vs-popup>

    </div>
    </div>
    </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { EmailEditor } from 'vue-email-editor';
import vSelect from "vue-select";
export default {
    name: "EmailTempUserRegister",
    components: {
        VuePerfectScrollbar,
        EmailEditor,
        vSelect
    },
    data() {
        return {
            form: {
                language: '',
                templateDetailId: null,
                templateId: null,
            },
            openLanguageUpdate: false,
            openLanguage: false,
            minHeight: "1000px",
            locale: "vi-VN",
            projectId: 0,
            tools: {
                image: {
                    enabled: true,
                },
            },
            options: {
                customJS: "console.log(1)",
                features: {
                    undoRedo: false,
                    audit: true,
                    textEditor: { cleanPaste: false },
                },
            },
            appearance: {
                theme: "dark",
                panels: {
                    tools: {
                        dock: "right",
                    },
                },
            },
            organizationId: null,
            dataTemplate: [],
            dataTemplateDetails: [],
            selectTemplate: null,
            selectTemplateDetails: null,
            checkTemplate: false,
            checkTemplateDetails: false,
            checkHtml: false,
            dataLanguage: [],
            selectLanguage: null,
            formUpdate: {
                language: '',
                settingValue: '',
                subject: '',
                templateDetailId: '',
            },
            dataTemplateCallback: null,

        }

    },

    created() {
        this.getEmailTemplate()

    },

    methods: {
        openHtml(){
            this.checkHtml = false
            this.getTemplate();
        },
        checkOpenLanguage() {
            this.openLanguageUpdate = true;
            this.dataLanguage.find(el => {
                if (el.value === this.selectLanguage) return this.formUpdate.language = el.label;
            })
        },
        ClearValue() {
            this.openLanguage = true;
            this.form.language = ''

        },
        checkValue() {
            if (this.selectTemplate) {
                this.selectTemplateDetails = ''
                this.getEmailTemplateDetail()
                this.checkTemplate = true;
                this.checkTemplateDetails = false
                this.formUpdate.subject ='',
                this.checkHtml = false
            }
        },
        checkValueDetail() {
            if (this.selectTemplateDetails) {
                this.selectLanguage = ''
                this.getLanguages();
                this.checkTemplateDetails = true;

            }
        },
        getEmailTemplate() {
            this.$vs.loading()
            this.$crm.get(`/setting/email-template/find-by-organization-id`).then((response) => {
                this.$vs.loading.close()
                if (response.data && response.data.length > 0) {
                    this.dataTemplate = response.data.map(el => {
                        return {
                            value: el.id,
                            label: el.title
                        }
                    })
                }
            }).catch(err => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
            })

        },
        getEmailTemplateDetail() {
            this.$vs.loading()
            this.$crm.get(`/setting/email-template-detail/find-by-template-id/${this.selectTemplate}`).then((response) => {
                this.$vs.loading.close()
                if (response.data && response.data.length > 0) {
                    this.dataTemplateDetails = response.data.map(el => {
                        return {
                            value: el.id,
                            label: el.title
                        }
                    })
                }
            }).catch(err => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: 'Gặp lỗi khi lấy ra dữ liệu',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
            })
        },
        addLanguage() {
            this.form.templateId = this.selectTemplate
            this.form.templateDetailId = this.selectTemplateDetails
            this.$vs.loading()
            this.$crm.post(`/setting/email-template-detail-language/create`, this.form).then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    color: 'success',
                    text: `Tạo mới thành công`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
                this.openLanguage = false
                this.getLanguages();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: 'Tạo mới thất bại!',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            })
        },
        getTemplate() {
            this.$crm.get(`/setting/email-template-detail-language/find-by-id/${this.selectLanguage}`).then((response) => {
                this.formUpdate.subject = response.data.subject
                this.dataTemplateCallback = response.data.settingValue
                    this.checkHtml = true
            })
        },
        getLanguages() {
            this.$crm.get(`/setting/email-template-detail-language/find-by-template-detail-id/${this.selectTemplateDetails}`).then((response) => {
                this.dataLanguage = response.data.map(el => {
                    return {
                        value: el.id,
                        label: el.language
                    }
                })
            }).catch(err => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: 'Không tìm thấy ngôn ngữ hiện tại!',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
            })
        },
        updateLanguage() {
                this.formUpdate.templateDetailId = this.selectTemplateDetails
                console.log(this.formUpdate)
            this.$vs.loading()
            this.$crm.post(`/setting/email-template-detail-language/update/${this.selectLanguage}`, this.formUpdate).then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    color: 'success',
                    text: `Cập nhật thành công`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
                this.openLanguageUpdate = false
                this.getLanguages()
            })
        },
        saveTemplate() {
                this.formUpdate.templateDetailId = this.selectTemplateDetails
                this.dataLanguage.find(el => {
                if (el.value === this.selectLanguage) return this.formUpdate.language = el.label;
            })
                console.log(this.formUpdate)
            this.$vs.loading()
            this.$crm.post(`/setting/email-template-detail-language/update/${this.selectLanguage}`, this.formUpdate).then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    color: 'success',
                    text: `Cập nhật thành công`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
                this.openLanguageUpdate = false
                this.getLanguages()
            })
        },
        deleteLanguage() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xóa`,
                text: `Bạn có chắc là muốn xóa mục này không ?`,
                accept: () => this.acceptDelete(),
                acceptText: "Xóa",
                cancelText: "Huỷ"

            })
        },
        acceptDelete() {
            this.$vs.loading()
            this.$crm.delete(`/setting/email-template-detail-language/delete/${this.selectLanguage}`).then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    color: 'success',
                    text: `Xóa thành công`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
                this.openPopupaddEmailItem = false
                this.selectLanguage = ''
                this.getLanguages()
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: 'Gặp lỗi khi xóa',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            })
        },


        // called when the editor is created
        editorLoaded() {
            var tempDesign = {
                "counters": {
                    "u_column": 1,
                    "u_row": 1,
                    "u_content_html": 1
                },
                "body": {
                    "id": "J2VNXaVC8C",
                    "rows": [
                        {
                            "id": "Q0AickVYBK",
                            "cells": [
                                1
                            ],
                            "columns": [
                                {
                                    "id": "3P5EPhkmXn",
                                    "contents": [
                                        {
                                            "id": "qDSwFkFfIw",
                                            "type": "html",
                                            "values": {
                                                "html": "<div style=\"background-color: #eeeeef; padding: 50px 0; \">\n  <div style=\"max-width:640px; margin:0 auto; \">\n    <div style=\"color: #fff; text-align: center; background-color:#33333e; padding: 30px; border-top-left-radius: 3px; border-top-right-radius: 3px; margin: 0;\">\n      <h1>Login Details Project Inviv Cloud</h1>\n    </div>\n    <div style=\"padding: 20px; background-color: rgb(255, 255, 255);\">\n      <p style=\"color: rgb(85, 85, 85); font-size: 14px;\"> Hello {USER_FIRST_NAME} {USER_LAST_NAME}, <br>\n        <br>An account has been created for you.\n      </p>\n      <p style=\"color: rgb(85, 85, 85); font-size: 14px;\"> Please use the following info to login your dashboard:</p>\n      <hr>\n      <p style=\"color: rgb(85, 85, 85); font-size: 14px;\">Dashboard URL:&nbsp; <a href=\"{DASHBOARD_URL}\" target=\"_blank\">{DASHBOARD_URL}</a>\n      </p>\n      <p style=\"color: rgb(85, 85, 85); font-size: 14px;\"></p>\n      <p style=\"\">\n        <span style=\"color: rgb(85, 85, 85); font-size: 14px; line-height: 20px;\">Email: {USER_LOGIN_EMAIL}</span>\n        <br>\n      </p>\n      <p style=\"\">\n        <span style=\"color: rgb(85, 85, 85); font-size: 14px; line-height: 20px;\">Password:&nbsp;{USER_LOGIN_PASSWORD}</span>\n      </p>\n      <p style=\"color: rgb(85, 85, 85);\">\n        <br>\n      </p>\n      <p style=\"color: rgb(85, 85, 85); font-size: 14px;\">{SIGNATURE}</p>\n    </div>\n  </div>\n</div>",
                                                "displayCondition": null,
                                                "containerPadding": "10px",
                                                "anchor": "",
                                                "_meta": {
                                                    "htmlID": "u_content_html_1",
                                                    "htmlClassNames": "u_content_html"
                                                },
                                                "selectable": true,
                                                "draggable": true,
                                                "duplicatable": true,
                                                "deletable": true,
                                                "hideable": true
                                            }
                                        }
                                    ],
                                    "values": {
                                        "backgroundColor": "",
                                        "padding": "0px",
                                        "border": {},
                                        "borderRadius": "0px",
                                        "_meta": {
                                            "htmlID": "u_column_1",
                                            "htmlClassNames": "u_column"
                                        }
                                    }
                                }
                            ],
                            "values": {
                                "displayCondition": null,
                                "columns": false,
                                "backgroundColor": "",
                                "columnsBackgroundColor": "",
                                "backgroundImage": {
                                    "url": "",
                                    "fullWidth": true,
                                    "repeat": "no-repeat",
                                    "size": "custom",
                                    "position": "center",
                                    "customPosition": [
                                        "50%",
                                        "50%"
                                    ]
                                },
                                "padding": "0px",
                                "anchor": "",
                                "hideDesktop": false,
                                "_meta": {
                                    "htmlID": "u_row_1",
                                    "htmlClassNames": "u_row"
                                },
                                "selectable": true,
                                "draggable": true,
                                "duplicatable": true,
                                "deletable": true,
                                "hideable": true
                            }
                        }
                    ],
                    "headers": [],
                    "footers": [],
                    "values": {
                        "popupPosition": "center",
                        "popupWidth": "600px",
                        "popupHeight": "auto",
                        "borderRadius": "10px",
                        "contentAlign": "center",
                        "contentVerticalAlign": "center",
                        "contentWidth": "500px",
                        "fontFamily": {
                            "label": "Arial",
                            "value": "arial,helvetica,sans-serif"
                        },
                        "textColor": "#000000",
                        "popupBackgroundColor": "#FFFFFF",
                        "popupBackgroundImage": {
                            "url": "",
                            "fullWidth": true,
                            "repeat": "no-repeat",
                            "size": "cover",
                            "position": "center"
                        },
                        "popupOverlay_backgroundColor": "rgba(0, 0, 0, 0.1)",
                        "popupCloseButton_position": "top-right",
                        "popupCloseButton_backgroundColor": "#DDDDDD",
                        "popupCloseButton_iconColor": "#000000",
                        "popupCloseButton_borderRadius": "0px",
                        "popupCloseButton_margin": "0px",
                        "popupCloseButton_action": {
                            "name": "close_popup",
                            "attrs": {
                                "onClick": "document.querySelector('.u-popup-container').style.display = 'none';"
                            }
                        },
                        "backgroundColor": "#e7e7e7",
                        "backgroundImage": {
                            "url": "",
                            "fullWidth": true,
                            "repeat": "no-repeat",
                            "size": "custom",
                            "position": "center"
                        },
                        "preheaderText": "",
                        "linkStyle": {
                            "body": true,
                            "linkColor": "#0000ee",
                            "linkHoverColor": "#0000ee",
                            "linkUnderline": true,
                            "linkHoverUnderline": true
                        },
                        "_meta": {
                            "htmlID": "u_body",
                            "htmlClassNames": "u_body"
                        }
                    }
                },
                "schemaVersion": 16
            };
            if(this.dataTemplateCallback) {
                let template = JSON.parse(this.dataTemplateCallback)
                this.$refs.emailEditor.loadDesign(template);
            } else {
                this.$refs.emailEditor.loadDesign(tempDesign);
            }
        },
        editorReady() {
            console.log('editorReady');
        },
        saveDesign() {
            this.$refs.emailEditor.editor.saveDesign((design) => {
                console.log('saveDesign', design);
                this.formUpdate.settingValue = JSON.stringify(design, null, 2);
                this.saveTemplate()
            });




        },
        exportHtml() {
            this.$refs.emailEditor.editor.exportHtml((data) => {
                console.log("exportHtml", data);
            });
        },
    }
}
</script>

<style scoped>
.unlayer-editor {
    height: 700px;
}

.blockbuilder-branding {
    display: none !important;
}

.customizeTitle {
    width: 100%;
}

.customizeTopEditor {
    margin-top: 0px !important;
    margin-bottom: 10px !important;
}

.con-select .vs-select {
    width: 100%
}

@media (max-width: 550px) {
    .con-select {
        flex-direction: column;
    }

    .con-select .vs-select {
        width: 100%
    }
}

html,
body {
    margin: 0;
    padding: 0;
    height: 100%;
    font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
}

#app,
#example {
    height: 100%;
}

#example .container {
    display: flex;
    flex-direction: column;
    position: relative;
    height: 100%;
}

#bar {
    flex: 1;
    background-color: #40B883;
    color: #FFF;
    padding: 10px;
    display: flex;
    max-height: 40px;
}

#bar h1 {
    flex: 1;
    font-size: 16px;
    text-align: left;
}

#bar button {
    flex: 1;
    padding: 10px;
    margin-left: 10px;
    font-size: 14px;
    font-weight: bold;
    background-color: #000;
    color: #FFF;
    border: 0px;
    max-width: 150px;
    cursor: pointer;
}
</style>

<style lang="scss"></style>
